import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { capitalize } from 'dpl/shared/utils';

const VALID_TAG_NAMES = [
  'input',
  'textarea',
  'select'
];

export default class ErrorWrapper extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    errors: PropTypes.arrayOf(PropTypes.node),
    isShown: PropTypes.bool,
    showDelay: PropTypes.number
  };

  static defaultProps = {
    errors: [],
    isShown: false,
    showDelay: 0
  };

  state = { errors: [] }

  timeoutId = null;

  /**
   * Only display new errors when user clicks away from input
   */
  handleBlur = (e) => {
    const { children, errors } = this.props;

    if (typeof children.props.onBlur === 'function') {
      children.props.onBlur(e);
    }

    window.clearTimeout(this.timeoutId);
    this.setState({ errors });
  };

  componentDidUpdate(prevProps, prevState) {
    const { errors, isShown } = this.props;

    const errorsChanged =
      prevState.errors.length !== errors.length ||
      prevState.errors.some(e => !errors.includes(e));

    if (
      errorsChanged && (
        // parent forced
        isShown ||
        // errors already displayed
        prevState.errors.length
      )
    ) {
      window.clearTimeout(this.timeoutId);

      if (!errors.length) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ errors: [] });
        return;
      }

      // debounced handler for setting state.errors
      // not using util's debounce because we need
      // to have a reference to the timeout to explicitly clear it
      this.timeoutId = window.setTimeout(() => {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ errors });
      }, this.props.showDelay);
    }
  }

  render() {
    const { children } = this.props;
    const { errors } = this.state;
    const hasErrors = errors.length > 0;

    return (
      <div
        className={ classnames('ErrorWrapper', {
          'ErrorWrapper--errored': hasErrors
        }) }
      >
        <div className="relative z-2">
          {
            // HACK to allow for custom input components :/
            VALID_TAG_NAMES.includes(children.props.Tag || children.type)
              ? cloneElement(children, {
                ...children.props,
                onBlur: this.handleBlur
              }) : children
          }
        </div>
        <div
          className={ classnames('ErrorWrapper__errorsContainer relative z-1', {
            mt1: errors.length > 0
          }) }
        >
          {
            errors.map(e => (
              <p key={ e } className="red f2">
                {
                  typeof e === 'string'
                    ? capitalize(e)
                    : e
                }
              </p>
            ))
          }
        </div>
      </div>
    );
  }
}
